import api from "./api";

export interface UserNotification {
  id: number;
  title: string;
  message: string;
  created_at: string;
  created_by_name?: string | null;
  is_read: number | boolean;
}

export interface AdminNotification {
  id: number;
  title: string;
  message: string;
  created_at: string;
  created_by_name?: string | null;
  target_roles: string[];
  is_active: number | boolean;
}

export const notificationService = {
  getMyNotifications: async (): Promise<UserNotification[]> => {
    const response = await api.get("/notifications/my");
    return response.data;
  },

  markAsRead: async (notificationId: number): Promise<void> => {
    await api.patch(`/notifications/${notificationId}/read`);
  },

  getAdminNotifications: async (): Promise<AdminNotification[]> => {
    const response = await api.get("/admin/notifications");
    return response.data;
  },

  createAdminNotification: async (payload: {
    title: string;
    message: string;
    targetRoles: string[];
  }): Promise<void> => {
    await api.post("/admin/notifications", payload);
  },

  updateAdminNotification: async (
    notificationId: number,
    payload: {
      title: string;
      message: string;
      targetRoles: string[];
      isActive?: boolean;
    },
  ): Promise<void> => {
    await api.put(`/admin/notifications/${notificationId}`, payload);
  },
};
